(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.initDropdowns();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }

    initDropdowns() {
      // Enhanced dropdown functionality for touch and keyboard
      const dropdownItems = document.querySelectorAll('.list-menu__item');
      
      dropdownItems.forEach(item => {
        const trigger = item.querySelector('.header__menu-item--has-dropdown');
        const submenu = item.querySelector('.header__submenu');
        
        if (!trigger || !submenu) return;

        // Touch device support - toggle on click/tap
        trigger.addEventListener('click', (e) => {
          // Check if it's a touch device or if we're handling dropdown toggle
          const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          
          if (isTouchDevice) {
            e.preventDefault();
            e.stopPropagation();
            
            // Close other open dropdowns
            document.querySelectorAll('.header__submenu.is-active').forEach(menu => {
              if (menu !== submenu) {
                menu.classList.remove('is-active');
              }
            });
            
            // Toggle current dropdown
            submenu.classList.toggle('is-active');
          }
        });

        // Keyboard navigation - Enter/Space to toggle, Escape to close
        trigger.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            submenu.classList.toggle('is-active');
            
            // Focus first link in submenu when opening
            if (submenu.classList.contains('is-active')) {
              const firstLink = submenu.querySelector('a');
              if (firstLink) firstLink.focus();
            }
          }
          
          if (e.key === 'Escape') {
            submenu.classList.remove('is-active');
            trigger.focus();
          }
        });

        // Arrow key navigation within submenu
        submenu.addEventListener('keydown', (e) => {
          const links = submenu.querySelectorAll('a');
          const currentIndex = Array.from(links).indexOf(document.activeElement);
          
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            const nextIndex = (currentIndex + 1) % links.length;
            links[nextIndex].focus();
          }
          
          if (e.key === 'ArrowUp') {
            e.preventDefault();
            const prevIndex = currentIndex <= 0 ? links.length - 1 : currentIndex - 1;
            links[prevIndex].focus();
          }
          
          if (e.key === 'Escape') {
            submenu.classList.remove('is-active');
            trigger.focus();
          }
        });
      });

      // Close dropdowns when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.list-menu__item')) {
          document.querySelectorAll('.header__submenu.is-active').forEach(submenu => {
            submenu.classList.remove('is-active');
          });
        }
      });

      // Close dropdowns on scroll for mobile
      let scrollTimer;
      window.addEventListener('scroll', () => {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          document.querySelectorAll('.header__submenu.is-active').forEach(submenu => {
            submenu.classList.remove('is-active');
          });
        }, 150);
      }, { passive: true });
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Cart icon bubble update
  document.addEventListener('DOMContentLoaded', function() {
    const cartIcon = document.getElementById('cart-icon-bubble');
    if (cartIcon) {
      // Update cart icon on cart changes
      document.addEventListener('cart:refresh', function(event) {
        if (event.detail && event.detail.cart) {
          const cart = event.detail.cart;
          const bubble = cartIcon.querySelector('.cart-count-bubble');
          
          if (cart.item_count > 0) {
            if (!bubble) {
              const newBubble = document.createElement('div');
              newBubble.className = 'cart-count-bubble';
              newBubble.innerHTML = `<span aria-hidden="true">${cart.item_count}</span>`;
              cartIcon.appendChild(newBubble);
            } else {
              bubble.querySelector('span[aria-hidden]').textContent = cart.item_count;
            }
          } else if (bubble) {
            bubble.remove();
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
